import { useState, useRef } from "react";
import { Button, Grid, IconButton, Popover, Typography } from "@mui/material";

interface VideoRateControlProps {
  playbackRate: number;
  handlePlaybackRate: (rate: number) => void;
}

const VideoRateControl = ({ playbackRate, handlePlaybackRate }: VideoRateControlProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const ratePopOverOpen = Boolean(anchorEl);
  const ratePopOverId = ratePopOverOpen ? "rate-popover" : undefined;
  const containerRef = useRef(null);

  return (
    <div ref={containerRef} style={{ margin: 0, padding: 0, overflow: "visible" }}>
      <Button
        aria-describedby={ratePopOverId}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        variant="text"
        sx={{
          color: "white",
          fontSize: "14px !important",
          width: "20px",
          textTransform: "lowercase",
          ":focus": { outline: "none" },
        }}
      >
        {playbackRate}x
      </Button>
      <Popover
        id={ratePopOverId}
        open={ratePopOverOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        container={containerRef.current}
      >
        <Grid container direction="column-reverse">
          {[0.5, 1.0, 1.5, 2.0].map((rate) => (
            <IconButton
              key={rate}
              onClick={() => {
                handlePlaybackRate(rate);
                setAnchorEl(null);
              }}
              sx={{ ":focus": { outline: "none" } }}
            >
              <Typography color={rate === playbackRate ? "secondary" : "inherit"} sx={{ fontSize: "14px !important" }}>
                {rate}x
              </Typography>
            </IconButton>
          ))}
        </Grid>
      </Popover>
    </div>
  );
};

export default VideoRateControl;
